<template>
    <CompassModal
        ref="popupAccountCodeEdit"
        v-model:visible="showModal"
        size="small"
        :title="title"
        class="popupAccountCodeEdit"
        @closed="$emit('close')"
    >
        <template #default>
            <div class="dialog__default">
                <div class="mb-1 typographies-heading-h4">{{ $l10n.__('TVA') }}</div>
                <el-input :modelValue="rateTaxFormatted" class="mb-3" disabled
                    >{{ $filters.numberFormat(tax.rate) }} %</el-input
                >

                <el-form ref="taxAccountingCodeForm" :model="dataForm" :rules="rules">
                    <!-- Code comptable Vente (débits) -->
                    <el-form-item
                        :error="errors.get('debit_collected_vat_id')"
                        class="mb-3"
                        prop="debit_collected_vat_id"
                    >
                        <div class="mb-1 typographies-heading-h4">
                            {{ $l10n.__('Code comptable Vente (débits)') }}
                        </div>
                        <CompassSelect
                            v-model="dataForm.debit_collected_vat_id"
                            menuClass="select-account-code"
                        >
                            <CompassDropdownOption
                                v-for="item in accountsCodes"
                                :key="item.id"
                                :label="`${item.code} - ${item.label}`"
                                :value="item.id"
                            />
                        </CompassSelect>
                    </el-form-item>
                    <!-- Code comptable Vente (encaissements) -->
                    <el-form-item
                        :error="errors.get('collection_collected_vat_id')"
                        class="mb-3"
                        prop="collection_collected_vat_id"
                    >
                        <div class="mb-1 typographies-heading-h4">
                            {{ $l10n.__('Code comptable Vente (encaissements)') }}
                        </div>
                        <CompassSelect
                            v-model="dataForm.collection_collected_vat_id"
                            menuClass="select-account-code"
                        >
                            <CompassDropdownOption
                                v-for="item in accountsCodes"
                                :key="item.id"
                                :label="`${item.code} - ${item.label}`"
                                :value="item.id"
                            />
                        </CompassSelect>
                    </el-form-item>
                    <!-- Code comptable Achat (débits) -->
                    <el-form-item
                        :error="errors.get('debit_deductible_vat_id')"
                        class="mb-3"
                        prop="debit_deductible_vat_id"
                    >
                        <div class="mb-1 typographies-heading-h4">
                            {{ $l10n.__('Code comptable Achat (débits)') }}
                        </div>
                        <CompassSelect
                            v-model="dataForm.debit_deductible_vat_id"
                            menuClass="select-account-code"
                        >
                            <CompassDropdownOption
                                v-for="item in accountsCodes"
                                :key="item.id"
                                :label="`${item.code} - ${item.label}`"
                                :value="item.id"
                            />
                        </CompassSelect>
                    </el-form-item>
                    <!-- Code comptable Achat (encaissements) -->
                    <el-form-item
                        :error="errors.get('collection_deductible_vat_id')"
                        prop="collection_deductible_vat_id"
                    >
                        <div class="mb-1 typographies-heading-h4">
                            {{ $l10n.__('Code comptable Achat (encaissements)') }}
                        </div>
                        <CompassSelect
                            v-model="dataForm.collection_deductible_vat_id"
                            menuClass="select-account-code"
                        >
                            <CompassDropdownOption
                                v-for="item in accountsCodes"
                                :key="item.id"
                                :label="`${item.code} - ${item.label}`"
                                :value="item.id"
                            />
                        </CompassSelect>
                    </el-form-item>
                </el-form>
            </div>
        </template>
        <template #footer>
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="$emit('close')"
                />
                <CompassButton
                    ref="savePopupAccountCodeEdit"
                    :label="$t.__('common.actions.save')"
                    class="ml-3"
                    @click="save"
                />
            </div>
        </template>
    </CompassModal>
</template>

<script>
import AccountingService from 'js/vue/api/accountingService.js';
import FormMixins from 'mixins/FormMixins';

export default {
    mixins: [FormMixins],
    props: {
        tax: {
            type: Object,
            required: true,
        },
        accountsCodes: {
            type: Array,
            required: true,
        },
        defaultCode: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showModal: true,
            dataForm: {
                debit_deductible_vat_id: this.tax.debit_vat.deductible_vat.id,
                debit_collected_vat_id: this.tax.debit_vat.collected_vat.id,
                collection_deductible_vat_id: this.tax.collection_vat.deductible_vat.id,
                collection_collected_vat_id: this.tax.collection_vat.collected_vat.id,
            },
            rules: {
                debit_deductible_vat_id: [
                    {
                        required: true,
                        message: this.$l10n.__('Veuillez choisir un code comptable'),
                        trigger: 'change',
                    },
                ],
                debit_collected_vat_id: [
                    {
                        required: true,
                        message: this.$l10n.__('Veuillez choisir un code comptable'),
                        trigger: 'change',
                    },
                ],
                collection_collected_vat_id: [
                    {
                        required: true,
                        message: this.$l10n.__('Veuillez choisir un code comptable'),
                        trigger: 'change',
                    },
                ],
                collection_deductible_vat_id: [
                    {
                        required: true,
                        message: this.$l10n.__('Veuillez choisir un code comptable'),
                        trigger: 'change',
                    },
                ],
            },
        };
    },
    computed: {
        rateTaxFormatted() {
            return `${this.$filters.numberFormat(this.tax.rate)} %`;
        },
        title() {
            return this.$l10n.__('Modifier ') + this.tax.label;
        },
    },
    created() {
        if (this.defaultCode?.id) {
            this.dataForm.collection_collected_vat_id ??
                (this.dataForm.collection_collected_vat_id = this.defaultCode.id);
            this.dataForm.collection_deductible_vat_id ??
                (this.dataForm.collection_deductible_vat_id = this.defaultCode.id);
        }
    },
    methods: {
        save() {
            this.$refs['taxAccountingCodeForm'].validate((valid) => {
                if (valid) {
                    const payload = {
                        debit_vat: {
                            collected_vat_id: this.dataForm.debit_collected_vat_id,
                            deductible_vat_id: this.dataForm.debit_deductible_vat_id,
                        },
                        collection_vat: {
                            collected_vat_id: this.dataForm.collection_collected_vat_id,
                            deductible_vat_id: this.dataForm.collection_deductible_vat_id,
                        },
                    };
                    AccountingService.updateTaxesWithAccountingCodes(payload, this.tax.id).then(
                        (response) => {
                            this.$emit('updateSuccessful', response);
                        },
                    );
                }
            });
        },
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.popupAccountCodeEdit {
    .dialog {
        &__default {
            padding-bottom: 24px;

            .compass-select {
                width: 100%;
            }
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }

    .el-input.is-disabled > input {
        background-color: $gray-05;
        border: 1px solid $gray-40;
        color: $gray-40;
    }

    .el-form-item.is-error.is-required {
        margin-bottom: 32px !important;
    }
}

.el-select-dropdown.el-popper {
    margin-top: 4px !important;

    .popper__arrow {
        display: none;
    }
}
#compass-dropdown-container {
    .select-account-code {
        z-index: 1001;
    }
}
</style>
